<template>
  <div>
    <el-form label-position="top"
             v-show="this.setp == '10'"
             class="register-fast-login"
             :model="enterpriseDataForm"
             :rules="dataRule"
             ref="enterpriseDataForm"
             status-icon>
      <el-form-item label="企业全称"
                    label-width="100px"
                    prop="companyName">
        <el-input v-model="enterpriseDataForm.companyName"
                  placeholder="请输入企业全称"></el-input>
      </el-form-item>
      <el-form-item label="社会统一信用代码"
                    label-width="100px"
                    prop="socialCreditCode">
        <el-input v-model="enterpriseDataForm.socialCreditCode"
                  placeholder="请输入您的信用代码"></el-input>
      </el-form-item>
      <el-form-item label="您的姓名"
                    label-width="100px"
                    prop="name">
        <el-input v-model="enterpriseDataForm.name"
                  placeholder="请输入您的姓名"></el-input>
      </el-form-item>
      <el-form-item label="邀请码"
                    label-width="100px"
                    prop="invitationCode">
        <el-input v-model="enterpriseDataForm.invitationCode"
                  placeholder="选填"></el-input>
      </el-form-item>

      <div class="tip">
        您的信息将被严格保密
      </div>
      <el-form-item>
        <el-button type="primary"
                   @click="next()"
                   class="w-percent-100 top-40">下一步</el-button>
      </el-form-item>
    </el-form>
    <el-form label-position="top"
             v-show="this.setp == '20'"
             class="register-fast-login"
             :model="enterpriseDataForm"
             :rules="dataRule"
             ref="enterpriseDataForm"
             status-icon>
      <el-form-item label="输入密码"
                    label-width="100px"
                    prop="password">
        <el-input v-model="enterpriseDataForm.password"
                  placeholder="请输入密码"></el-input>
      </el-form-item>
      <el-form-item label="再次确认密码"
                    label-width="100px"
                    prop="rePassword">
        <el-input v-model="enterpriseDataForm.rePassword"
                  placeholder="请再次输入您的密码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   @click="enterpriseDataFormSubmitHandle()"
                   class="w-percent-100 top-40">完成注册</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      mobile: '',
      enterpriseDataForm: {
        username: '',
        name: '',
        companyName: '',
        password: '',
        rePassword: '',
        socialCreditCode: '',
        registerType: 2,
        invitationCode: ''
      },
      setp: '10'
    }
  },
  computed: {
    dataRule () {
      return {
        name: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        socialCreditCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.setp = '10'
  },
  methods: {
    next () {
      this.$refs['personDataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.setp = '20'
      })
    },
    enterpriseDataFormSubmitHandle: debounce(function () {
      this.$refs['enterpriseDataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        if (!this.enterpriseDataForm.password) {
          this.$message.warning('请输入密码')
          return
        } else if (!this.enterpriseDataForm.rePassword) {
          this.$message.warning('请再次输入密码')
          return
        } else if (this.enterpriseDataForm.rePassword !== this.enterpriseDataForm.password) {
          this.$message.warning('两次密码输入不一致')
          return
        }
        let Base64 = require('js-base64').Base64
        this.$http.post(`/front/consumer/user/register`, {
          username: this.mobile,
          name: this.enterpriseDataForm.name,
          companyName: this.enterpriseDataForm.companyName,
          password: Base64.encode(this.enterpriseDataForm.password),
          socialCreditCode: this.enterpriseDataForm.socialCreditCode,
          registerType: 2,
          invitationCode: this.enterpriseDataForm.invitationCode,
          appCode: 'PLANTMATE_OFFICIAL',
          clientId: 'android'
        })
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return this.$message.error(res.msg)
            }
            Cookies.set('access_token_shop', res.access_token)
            window.SITE_CONFIG['permissions'] = res.permissions || []
            this.$router.replace({ name: 'home' })
          }).catch(() => { })
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
<style lang="scss" scoped>
.tip {
  color: #666;
  font-size: 12px;
  margin-top: 10px;
}
</style>
